module.exports = __webpack_public_path__ + "img/recruiting-active.a6ff4b93.svg";